import axios from 'axios';
import AuthService from './AuthService';

const API_URL = process.env.REACT_APP_API_URL;

// ReferenceHandler.Preserve wraps arrays as { "$id": "1", "$values": [...] }
const unwrapArray = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (data.$values && Array.isArray(data.$values)) return data.$values;
  return [];
};

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

const DashboardService =
{
    async getDashboardCards(userId, clientId, startDate, endDate) {
        try {
          const response = await axios.get(`${API_URL}/Dashboard/${userId}/${clientId}/${startDate}/${endDate}`);
          const data = response.data;
          return {
            leadCount: data.leadCount,
            interestedCount: data.interestedCount,
            upcomingVisitCount: data.upcomingVisitCount,
            phoneNotPickedCount: data.phoneNotPickedCount,
            invalidNumberCount: data.invalidNumberCount,
            callBackLaterCount: data.callBackLaterCount,
            completeCount: data.completeCount,
            totalCallsCount: data.totalCallsCount,
            leadAssignedCount: data.leadAssignedCount,
            visitedCount: data.visitedCount,
            hotClientCount: data.hotClientCount,
            stageCounts: data.stageCounts || {},
          };
        } catch (error) {
          console.error(`Error fetching DashboardCards with ID ${userId}:`, error);
          throw error;
        }
    },

    async getSourcePerformance(clientId, startDate, endDate) {
        const response = await axios.get(
          `${API_URL}/Dashboard/SourcePerformance/${clientId}/${startDate}/${endDate}`
        );
        return unwrapArray(response.data);
    },

    async getConversionReport(clientId, startDate, endDate) {
        const response = await axios.get(
          `${API_URL}/Dashboard/ConversionReport/${clientId}/${startDate}/${endDate}`
        );
        return response.data;
    },

    async getEmployeePerformance(clientId, startDate, endDate) {
        const response = await axios.get(
          `${API_URL}/Dashboard/EmployeePerformance/${clientId}/${startDate}/${endDate}`
        );
        return unwrapArray(response.data);
    },

    async getHotLeads(clientId, limit = 6) {
        const response = await axios.get(`${API_URL}/Dashboard/HotLeads/${clientId}?limit=${limit}`);
        return unwrapArray(response.data);
    },

    async getRecentActivity(clientId, limit = 10) {
        const response = await axios.get(`${API_URL}/Dashboard/RecentActivity/${clientId}?limit=${limit}`);
        return unwrapArray(response.data);
    },

    async getSuperAdminOverview(startDate, endDate) {
        const response = await axios.get(
          `${API_URL}/Dashboard/SuperAdminOverview/${startDate}/${endDate}`
        );
        return unwrapArray(response.data);
    },

    async sendSms(toPhone, body) {
        const response = await axios.post(`${API_URL}/Messaging/sms`, { toPhone, body });
        return response.data;
    },

    async sendWhatsApp(toPhone, body) {
        const response = await axios.post(`${API_URL}/Messaging/whatsapp`, { toPhone, body });
        return response.data;
    },
};
export default DashboardService;